export const SELECT_ALL = 'SELECT_ALL';
export const CLEAR_ALL = 'CLEAR_ALL';
export const ONLY = 'ONLY';
export type SelectAll = 'SELECT_ALL';
export type ClearAll = 'CLEAR_ALL';
export type Only = 'ONLY';
